define('SageDotCom/DataLayer/Global/header-menu-tracker',[
    "jquery",
    "SageDotCom/DataLayer/Events/top-nav-interaction",
    "SageDotCom/DataLayer/Events/top-nav-select",
],
function ($, TopNavInteractionEvent, TopNavSelectEvent) {
    
    function HeaderMenuTracker() {
        this.scope = document.querySelectorAll('header nav.score-megamenu, header .score-button-group:not(nav.score-megamenu *)');
    }

    HeaderMenuTracker.prototype.start = function () {
        // Disable tracking in case if site header is not presented on the page
        if (!(this.scope && this.scope.length > 0)) return;

        // Track expanding of dropdown menus
        $(".score-megamenu-dropdown", this.scope).on("show.bs.dropdown", onDropdownMenuExpand);
        $(".modal-launch-btn:not(nav.score-megamenu .score-button-group *):first", this.scope).on("click", onLoginButtonClick);

        // Track clicking on basic menu item
        $(".score-megamenu-basic-item", this.scope).on("click", onBasicMenu);

        // Track clicking on back button
        $(".back-button", this.scope).on("click", onBackBtnClick);

        // Track expanding of mobile menu(hamburger)
        $(".navbar-collapse", this.scope).on("show.bs.collapse", onMobileMenuExpand.bind(this));

        // Track expanding of search suggestions

        for (var i = 0; i < this.scope.length; i++) {
            var searchResultsMenu = this.scope[i].querySelector(".tt-menu");
            if (searchResultsMenu) {
                var observer = new MutationObserver(onSearchSuggestionsExpand.bind(searchResultsMenu));
                observer.observe(searchResultsMenu, { attributes: true });
            }
        }

        // Track click on links in menu and search suggestions that navigate to new page
        $(this.scope).on("click", "a[href]:not([href^='#'])", onLinkClick);
        $(".login-modal").on("click", "a[href]:not([href^='#'])", onLinkClick);
    }

    function onDropdownMenuExpand(e) {
        var el = e.currentTarget;
        var label = e.currentTarget.querySelector("button, a").innerText;
        new TopNavInteractionEvent(el, label).trigger();
    }

    function onLoginButtonClick(e) {
        var el = e.currentTarget;
        var label = e.currentTarget.text;
        new TopNavInteractionEvent(el, label).trigger();
    }

    function onBackBtnClick(e) {
        var el = e.currentTarget;
        var label = e.currentTarget.innerText;
        new TopNavInteractionEvent(el, label).trigger();
    }

    function onBasicMenu(e) {
        var el = e.currentTarget;
        var label = e.currentTarget.querySelector("a").text;
        new TopNavInteractionEvent(el, label).trigger();
    }

    function onMobileMenuExpand(e) {
        var toggleMenuButton = this.scope[0].querySelector('[data-target*="' + e.currentTarget.id + '"]');
        var label = 'expand mobile menu';
        new TopNavInteractionEvent(toggleMenuButton, label).trigger();
    }

    function onSearchSuggestionsExpand(e) {
        if (this.style.display == 'block') {
            var label = "expand search suggestions";
            new TopNavInteractionEvent(this, label).trigger();
        }
    }

    function onLinkClick(e) {
        var isSearchSuggestionLink = e.currentTarget.parentElement.classList.contains('tt-suggestion');
        var isLoginButton = $(e.currentTarget).is(".modal-launch-btn:not(nav.score-megamenu .score-button-group *):first");
        // Trigger top_nav_select event for menu links only excluding search suggestion links
        if (!isSearchSuggestionLink && !isLoginButton) {
            new TopNavSelectEvent(e.currentTarget).trigger();
        }
    }

    return HeaderMenuTracker;
});
